<template>
    <div class="index">
        <!-- appbar -->
        <mu-appbar style="width: 100%;position:fixed;" color="primary">
            <mu-button icon slot="left" @click="jumpBack()" v-if="showBack">
                <mu-icon value="chevron_left" size="30" color="#fff" @click="jumpBack"></mu-icon>
            </mu-button>
            <div class="nav-title">
                {{$t('buffetselect.title')}}
            </div>
            <mu-menu slot="right" style="margin-right:10px;margin-top:16px;" class="notranslate" :open.sync="isMenuOpen">
                    <mu-button fab small color="success">
                        {{getLanage()}}
                    </mu-button>
                    <mu-list slot="content">
                        <mu-list-item button @click="selectLanage('DK')">
                            <mu-list-item-title>DK</mu-list-item-title>
                        </mu-list-item>
                        <mu-list-item button @click="selectLanage('EN')">
                            <mu-list-item-title>EN</mu-list-item-title>
                        </mu-list-item>
                        <mu-list-item button @click="selectLanage('PT')">
                            <mu-list-item-title>PT</mu-list-item-title>
                        </mu-list-item>
                        <mu-list-item button @click="selectLanage('中文')">
                            <mu-list-item-title>中文</mu-list-item-title>
                        </mu-list-item>
                    </mu-list>
                </mu-menu>
        </mu-appbar>

        <!-- content -->
        <mu-container class="select-content">
            <div class="buffet-page">
                <div class="banner-wrap" v-if="seller.buffetBannerImage">
                    <img class="banner" :src="getImgUrl(seller.buffetBannerImage,400)" alt="banner" />
                </div>

                <div class="tip-card" v-if="configsData.NumberTip">
                    <mu-icon value="info" size="18" class="tip-icon"></mu-icon>
                    <div class="tip-text" v-html="formattedNumberTip"></div>
                </div>

                <mu-form ref="form" class="buffet-form" :model="packageQuantity">
                    <div class="package-card" v-for="food, index in buffetPackageList" :key="index">
                        <div class="package-head">
                            <div class="package-name">{{ food.foodName }}</div>
                            <div class="package-price">
                                <span class="price-num">{{ food.price }}</span>
                                <span class="price-unit">{{ seller.unit }}</span>
                            </div>
                        </div>

                        <div class="package-desc" v-if="food.description" v-html="food.description"></div>

                        <div class="num-grid">
                            <div class="badge-num" :class="{select:i==food.current}" @click="selectNum(i,val,food)" v-for="(val,i) in options" :key="i">{{val}}</div>
                        </div>
                        <mu-text-field v-if="food.isMore" v-model="food.quantity" @change="statistical" type="number" class="more-input" placeholder="more number"></mu-text-field>
                    </div>

                    <div class="confirm-card" v-if="configsData.ChkRequireConfirm==1">
                        <mu-checkbox v-model="chkRequireConfirm" :label="formattedLabel" class="multiline-label">
                        </mu-checkbox>
                    </div>
                </mu-form>

                <div class="action-bar">
                    <div class="total-block">
                        <span class="total-label">{{ $t('buffet.total') }}</span>
                        <span class="total-value">{{ totalPrice }} <em>{{ seller.unit }}</em></span>
                    </div>
                    <mu-button class="submit-btn" :disabled="btnDisabled" @click="next">
                        {{$t('buffetselect.next')}}
                    </mu-button>
                </div>
            </div>

            <mu-dialog :title="$t('buffetselect.successfulOrderTip')" width="360" height="220" :open.sync="openSimple" >
                {{$t('buffetselect.successTip')}}
            </mu-dialog>

            <!-- 已选套餐提示弹窗 -->
            <mu-dialog width="420" :open.sync="openPackageAlert" :title="$t('buffetselect.packageAlreadySelectedTip')">
                <div class="alert-packages">
                    <div v-for="(pkg, idx) in selectedPackages" :key="idx" class="alert-pkg-item">
                        <span>{{ pkg.foodName }}</span>
                        <span class="alert-pkg-qty">{{ pkg.quantity }}</span>
                    </div>
                </div>
                <div slot="actions" class="alert-actions">
                    <mu-button color="primary" full-width @click="confirmContinueOrder" style="background-color:#da5b3a;text-transform:unset;">
                        {{ $t('buffetselect.confirmContinueOrder') }}
                    </mu-button>
                    <mu-button full-width @click="cancelContinueOrder" style="background-color:#4caf50;color:#fff;text-transform:unset;">
                        {{ $t('buffetselect.modifyPackageNum') }}
                    </mu-button>
                </div>
            </mu-dialog>
        </mu-container>

    </div>
</template>
<script>
    import preventBack from 'vue-prevent-browser-back';
    export default {
        name: 'BuffetSelect',
        mixins: [preventBack],//注入  阻止返回上一页
        data() {
            return {
                buffetPackageList: [],
                configsData:[],
                seller: {},
                tableOrderInfo: {},
                packageQuantity: {},
                orderBuffetList: [],
                totalPrice:0,
                openSimple: false,
                openNumber: false,
                openPackageAlert: false,
                alertShownForQty: -1,
                btnDisabled: false,
                showBack: false,
                isMenuOpen: false,
                chkRequireConfirm:false,
                pollTimer: null,
                storageHandler: null,
                options: [
                    '0', '1', '2', '3', '4',
                    '5', '6', '7', '8','9', '10',
                    'More'
                ],
                moreOptions: [
                    '0','1', '2', '3', '4',
                    '5', '6', '7', '8',
                    '9', '10', '11', '12',
                    '13', '14', '15', '16',
                    '17', '18', '19', '20',
                    '21', '22', '23',
                    'More'
                ],
            }
        },
        components: {
        },
        mounted() {
            this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
            this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
            this.getRestaurantInfo();
            this.getConfigs();
            // 多用户实时同步：轮询刷新套餐数据
            this.pollTimer = setInterval(() => {
                this.refreshOrderBuffetData();
            }, 20000);
            // 监听其他标签页 storage 变化
            this.storageHandler = (e) => {
                if (e.key === 'tableOrderInfo' || e.key === 'seller') {
                    this.refreshOrderBuffetData();
                }
            };
            window.addEventListener('storage', this.storageHandler);
        },
        beforeDestroy() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer);
                this.pollTimer = null;
            }
            if (this.storageHandler) {
                window.removeEventListener('storage', this.storageHandler);
                this.storageHandler = null;
            }
        },
        computed: {
             formattedNumberTip() {
                return this.configsData.NumberTip
                .replace(/\/s\/t/g, '<br>')  
                .replace(/\\n/g, '<br>');
            },
              formattedLabel() {
                return this.configsData.RequireConfirmInfo
                .replace(/\/s\/t/g, '\n')  
                .replace(/\\n/g, '\n')
                .replace(';', '\n');  
            },
            selectedPackages() {
                // 优先展示服务器端已提交的套餐，没有时才展示本地已选
                const remote = this.orderBuffetList.filter(o => o.quantity > 0);
                if (remote.length > 0) {
                    return remote.map(o => ({
                        foodName: o.foodName,
                        quantity: o.quantity
                    }));
                }
                return this.buffetPackageList
                    .filter(f => f.quantity > 0)
                    .map(f => ({ foodName: f.foodName, quantity: f.quantity }));
            }
        },
        methods: {
          
            async getConfigs() {  
                await this.$get('QRCodeBasicInfo/GetConfigs', { restaurantId: this.tableOrderInfo.restaurantId})
                    .then(response => {
                        if(response.code==200){
                            response.data.forEach((item) => {
                                this.configsData[item.configKey]= item.configValue;
			                })
                        }
                    });
            },
            getRestaurantInfo() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId
                };
                this.$get('QRCodeBasicInfo/GetRestaurant', param)
                    .then(response => {
                        if (response.code==200) {
                            this.seller = response.data;
                            this.getOrderBuffetList();
                            window.localStorage.setItem('seller', JSON.stringify(this.seller));
                            this.getLanage();
                        } else {
                            this.$alert(this.$t("common.connotAccessed"), this.$t("common.alert"));
                        }
                    });
            },
            getLanage() {
                if (localStorage.getItem('lang') != undefined && localStorage.getItem('lang') != null) {
                    this.$i18n.locale = localStorage.getItem('lang');
                    return localStorage.getItem('lang');
                }
                this.$i18n.locale = this.seller.language;
                return this.seller.language;
            },
            selectLanage(lng) {
                this.$i18n.locale = lng;
                localStorage.setItem('lang', lng);
                this.isMenuOpen=false;
            },
            getBuffetList() {
                let param = {
                    restaurantId: this.seller.restaurantId
                };
                this.$get('QRCodeOrder/GetBuffetPackageList', param)
                    .then(response => {
                        if (response.code==200) {
                            response.data.forEach((food) => {
                                if (food.actDiscount==0) {
                                    food.actDiscount = 1;
                                }
                                food.isMore = false;
                                food.current = 0;
                                for (var m = 0; m < this.orderBuffetList.length; m++) {
                                    if (this.orderBuffetList[m].foodId == food.foodId) {
                                        food.quantity = this.orderBuffetList[m].quantity;
                                        this.showBack = true;
                                        if (food.quantity > 10) {
                                            food.isMore = true;
                                            food.current = food.quantity;
                                        }
                                        else {
                                            food.current = food.quantity;
                                            food.isMore = false;
                                        }
                                        break;
                                    }
                                }
                                food.originPrice=food.price;
                                this.buffetPackageList.push(food);
                            })
                            this.statistical();
                            this.checkPackageQuantity();
                        }
                    });
            },
            // 检查是否已有选好的套餐，有则弹出提示
            checkPackageQuantity() {
                const hasSelected = this.buffetPackageList.some(f => f.quantity > 0);
                const totalQty = this.buffetPackageList.reduce((s, f) => s + (parseInt(f.quantity) || 0), 0);
                if (hasSelected && totalQty !== this.alertShownForQty) {
                    this.alertShownForQty = totalQty;
                    this.openPackageAlert = true;
                } else if (!hasSelected) {
                    this.alertShownForQty = -1;
                }
            },
            // 轮询刷新：只拉取服务器端已提交的套餐，用于弹出提示
            // 绝对不修改 buffetPackageList，避免覆盖用户正在操作的数据
            refreshOrderBuffetData() {
                this.tableOrderInfo = this.getItem('sessionStorage', 'tableOrderInfo') || this.tableOrderInfo;
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                this.$get('QRCodeOrder/GetOrderBuffetPackage', param)
                    .then(response => {
                        if (response.code == 200) {
                            this.orderBuffetList = response.data;
                            // 仅检查服务器端是否有已提交的套餐 → 触发弹窗
                            const hasRemoteSelected = response.data.some(o => o.quantity > 0);
                            const totalRemoteQty = response.data.reduce((s, o) => s + (parseInt(o.quantity) || 0), 0);
                            if (hasRemoteSelected && totalRemoteQty !== this.alertShownForQty) {
                                this.alertShownForQty = totalRemoteQty;
                                this.openPackageAlert = true;
                            } else if (!hasRemoteSelected) {
                                this.alertShownForQty = -1;
                            }
                        }
                    });
            },
            // 按钮1：确认进行点餐（跳过本页直接进 buffet）
            confirmContinueOrder() {
                this.openPackageAlert = false;
                this.jumpBuffetMain();
            },
            // 按钮2：进行修改套餐人数（关闭弹窗，允许用户在本页调整）
            cancelContinueOrder() {
                this.openPackageAlert = false;
            },
            getOrderBuffetList() {
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                this.$get('QRCodeOrder/GetOrderBuffetPackage', param)
                    .then(response => {
                        if (response.code==200) {
                            this.orderBuffetList = response.data;
                        }
                        this.getBuffetList();
                    });
            },
            timeOutCheck() {
                var time = window.localStorage.getItem('timeOut');
                let that = this;
                if (time != undefined && time != null && time != "") {
                    var dateTimeStamp = new Date(time.replace(/-/g, '/')).getTime();
                    var now = new Date().getTime();
                    var diffValue = now - dateTimeStamp;
                    var minute = 1000 * 60;
                    var minC = diffValue / minute;
                    if (parseInt(minC) >= 120) {
                        this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                            type: 'warning', okLabel: this.$t("common.ok"),
                        }).then(function (result, value) {
                            that.$router.push({
                                path: '/error'
                            })
                        });
                        return false;
                    }
                    return true;
                }
                this.$alert(this.$t("common.pageInvalid"), this.$t("common.alert"), {
                    type: 'warning', okLabel: this.$t("common.ok"),
                }).then(function (result, value) {
                    that.$router.push({
                        path: '/error'
                    })
                });
                return false;
            },
            next() {
                this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                if (!this.timeOutCheck()) {
                    return;
                }
                let foods = [];
                let curNum = 0;
                this.buffetPackageList.forEach((food) => {
                    if (food.quantity) {
                        foods.push(food);
                        curNum += parseInt(food.quantity);
                    }
                })
                if (foods.length == 0) {
                    this.$alert(this.$t("common.selectPackage"), this.$t("common.alert"), { okLabel: this.$t("common.sure")});
                    return;
                }
                if(this.configsData.ChkRequireConfirm==1 && !this.chkRequireConfirm){
                     this.$alert(this.formattedLabel, this.$t("header.info"), { okLabel: this.$t("common.sure")}).then(() => {
                         this.chkRequireConfirm=true;
                    });
                    return;
                }

                this.btnDisabled = true;
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName
                };
                this.$get('QRCodeOrder/GetOrderBuffetPackage', param)
                    .then(response => {
                        if (response.code==200 && response.data.length>0) {
                            this.orderBuffetList = response.data;
                            var num1 = 0;
                            this.orderBuffetList.forEach((food) => {
                                num1 += parseInt(food.quantity);
                            })
                            this.tableOrderInfo.number = num1;
                            var num2 = 0;
                            foods.forEach((food) => {
                                num2 += parseInt(food.quantity);
                            })
                            if (num2 < num1) {
                                this.btnDisabled = false;
                                this.$alert(this.$t("common.increased"), this.$t("common.alert"), { okLabel: this.$t("common.sure") });
                                return;
                            }
                            this.btnDisabled = true;
                            this.$confirm(this.$t("common.moreNeed", { beginNum: num1, nowNum:(num2 - num1)}), this.$t("common.submit"), {
                                type: 'info',
                                okLabel: this.$t("common.ok"),
                                cancelLabel: this.$t("common.cancel")
                            }).then(({ result }) => {
                                if (result) {
                                    this.tableOrderInfo.number = num2;
                                    window.localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                                    this.addOrderCart(foods);
                                }
                                else {
                                    this.tableOrderInfo.number = num1;
                                    window.localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                                    this.$router.push({ path: '/buffet' });
                                }
                            })
                        }
                        else {
                            this.tableOrderInfo.number = curNum;
                            window.localStorage.setItem('tableOrderInfo', JSON.stringify(this.tableOrderInfo));
                            this.addOrderCart(foods);
                        }
                    });
               
            },
            addOrderCart(foods) {
                this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');
                var tempFoods = [];
                foods.forEach((food) => {
                    var isHas = false;
                    for (var m = 0; m < this.orderBuffetList.length; m++) {
                        if (this.orderBuffetList[m].foodId == food.foodId) {
                            isHas = true;
                            food.quantity = food.quantity - this.orderBuffetList[m].quantity;
                            if (food.quantity > 0) {
                                tempFoods.push(food);
                            }
                            break;
                        }
                    }
                    if (!isHas) {
                        tempFoods.push(food);
                    }
                })
                if (tempFoods.length == 0) {
                    this.$router.push({ path: '/buffet' });
                    return;
                }

                var cartList = [];
                tempFoods.forEach((food) => {
                    cartList.push({
                        RestaurantId: this.tableOrderInfo.restaurantId,
                        TableName: this.tableOrderInfo.tableName,
                        FoodTypeName: food.foodTypeName,
                        FoodId: food.foodId,
                        FoodName: food.foodName,
                        FoodImage: food.foodImage,
                        Price: food.price,
                        Quantity: food.quantity,
                        FoodDiscount: food.actDiscount,
                        DecideName: food.decideName == undefined ? "" : food.decideName,
                        CreateUser: this.tableOrderInfo.name,
                        CreatePhone: this.tableOrderInfo.telephone,
                        IsSeft: 0,
                        AllowDiscounts: food.allowDiscounts,
                    })
                })
                let param = {
                    restaurantId: this.tableOrderInfo.restaurantId,
                    tableName: this.tableOrderInfo.tableName,
                    shopCartList: JSON.stringify(cartList)
                };
                this.$post('QRCodeOrder/AddtoCartList',param)
                    .then(response => {
                        if (response.code == 200) {
                            this.order();
                        } else {
                            this.$alert(this.$t("common.connotAccessed"), this.$t("common.alert"));
                        }
                    });
            },
            dataLen(d) {
                if (d < 10) {
                    return "0" + d;
                }
                return d;
            },
            order() {
                this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
                this.tableOrderInfo = this.getItem('sessionStorage','tableOrderInfo');

                var myDate = new Date();
                var orderDate = myDate.getFullYear() + "-" + this.dataLen(myDate.getMonth() + 1) + "-" + this.dataLen(myDate.getDate()) + " " + this.dataLen(myDate.getHours()) + ":" + this.dataLen(myDate.getMinutes()) + ":00";
                let param = {
                    OrderType: 1,
                    RestaurantId: this.seller.restaurantId,
                    TableName: this.tableOrderInfo.tableName,
                    OrderFrom: 5,
                    OrderDay: orderDate,
                    DeliveryType:1,
                    OrderProcess:1,
                    OrderAmount: 0,
                    OrderDiscount: 1,
                    ActualAmount: 0,
                    PostAmount: 0,
                    CouponAmount: 0,
                    State:1,
                    CustomerName: this.tableOrderInfo.name,
                    Telephone: this.tableOrderInfo.telephone,
                    Adult: this.tableOrderInfo.number,
                    Child: 0,
                    Specielle: this.tableOrderInfo.specielle,
                    PaymentType:0,
                    IsInvoice:0,
                    IsConformed:0,
                    OrderId: 0,
                    AccountId:0,
                    Rabatkode: '',
                    IsOrderBuffetPackage:1,
                    IsSendSms: this.tableOrderInfo.isSendSms,
                    RedisKey: this.orderRediskey + this.tableOrderInfo.restaurantId+"-"+ this.tableOrderInfo.tableName
                }
                this.$post('QRCodeOrder/OrderQRCodeCartList', param)
                    .then(response => {
                            if (response.code == 200) {
                                this.openSimple = true;
                                let timer0 = setTimeout(() => {
                                    this.openSimple = false;
                                    this.jumpBuffetMain();
                                }, 2000)
                            }
                            else {
                                this.$alert(this.$t(response.msg), this.$t("common.alert"), { type: 'warning', okLabel: this.$t("common.sure") });
                            }
                    });
            },
            selectNum(index, val, food) {
                food.current = index;
                if (val != 'More') {
                    food.isMore = false;
                    if (val == 0) {
                        food.quantity = "";
                    }
                    else {
                        food.quantity = val;
                    }
                }
                else {
                    // if (this.options != this.moreOptions) {
                    //     this.options = this.moreOptions;
                    // }
                    // else {
                        food.isMore = true;
                    //}
                }
                this.statistical();
            },
            statistical() {
                this.totalPrice = 0;
                this.buffetPackageList.forEach((food) => {
                    var quantity = Number(food.quantity) || 0;
                    if(food.priceRules!=null && food.priceRules!=''){
                        var rules=JSON.parse(food.priceRules);
                        if(rules.length>0){
                            var rule=rules[0];
                            if(quantity>=rule.value){
                                food.price=rule.price;
                            }
                            else{
                                food.price=food.originPrice;
                            }
                        }
                    }
                    this.totalPrice += quantity * food.price;
                });
            },
            clear(food) {
                food.quantity = null;
            },
            getImgUrl(image,w=0) {
                if (image == undefined || image == 'undefined' || image == null|| image == '') {
                    return '../static/img/default.png';
                }
                if(w==0){
                    return this.global.baseUrl + "uploads/" + image
                }
                return  this.global.baseUrl+"api/images/"+w+"/"+ image
            },
            refresh() {
                this.$toast.success('Refresh successfully!');
            },
            jumpBuffetMain() {
                this.$router.push({ path: '/buffet' });
            },
            jumpIndex() {
                this.$router.push({ path: '/' });
            },
            jumpBack() {
                this.$router.push({ path: '/buffet' });
            },
        },
        activated() {
            
        }
    }
</script>
<style>
/* 让 mu-checkbox 的 label 支持多行并自动撑开 */
.multiline-label.mu-checkbox {
  display: flex !important;
  align-items: flex-start !important;
  height: auto !important;
  min-height: 24px;
  padding: 4px 0;
}

.multiline-label .mu-checkbox-label {
  white-space: pre-line;
  word-break: break-word;
  line-height: 1.5;
  text-align: left;
  vertical-align: top;
  padding-left: 10px;
  height: auto !important;
  min-height: 24px;
  display: inline-block;
  overflow: visible;
}

/* 确保 mu-checkbox 本身也能自适应（复选框方块顶部对齐） */
.multiline-label .mu-checkbox-box,
.multiline-label > .mu-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.multiline-label > .mu-checkbox-label {
  flex: 1;
  height: auto !important;
}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    .nav-title {
        text-align: center;
    }

    .mu-list {
        padding: 5px 0;
    }

    .mu-button {
        text-transform: unset;
    }

    .select-content {
        padding-left: 0px;
        padding-right: 0px;
        top: 58px;
        position: absolute;
        width: 100%;
        bottom: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        background-color: #f4f5f7;
    }

    .buffet-page {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        max-width: 720px;
        margin: 0 auto;
        padding: 12px 14px 0;
        box-sizing: border-box;
    }

    /* ===== 顶部横幅 ===== */
    .banner-wrap {
        margin-bottom: 12px;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 2px 10px rgba(17, 24, 39, 0.08);
    }

    .banner {
        display: block;
        width: 100%;
        max-height: 220px;
        object-fit: cover;
    }

    /* ===== 人数提示 ===== */
    .tip-card {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        padding: 10px 12px;
        margin-bottom: 12px;
        border-radius: 10px;
        background-color: #fff7ed;
        border-left: 3px solid #da5b3a;
        color: #8a5a44;
    }

    .tip-icon {
        color: #da5b3a;
        flex-shrink: 0;
        margin-top: 1px;
    }

    .tip-text {
        font-size: 12.5px;
        line-height: 1.6;
        word-break: break-word;
    }

    .tip-text >>> p {
        margin: 0 0 4px;
    }

    .tip-text >>> p:last-child {
        margin-bottom: 0;
    }

    /* ===== 套餐卡片 ===== */
    .buffet-form {
        width: 100%;
        margin: 0;
    }

    .package-card {
        padding: 14px 14px 12px;
        margin-bottom: 12px;
        border-radius: 12px;
        background-color: #fff;
        box-shadow: 0 1px 4px rgba(17, 24, 39, 0.06);
    }

    .package-head {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 10px;
    }

    .package-name {
        flex: 1;
        min-width: 0;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.35;
        color: #2b2f36;
        word-break: break-word;
    }

    .package-price {
        flex-shrink: 0;
        color: #da5b3a;
        white-space: nowrap;
    }

    .price-num {
        font-size: 17px;
        font-weight: 700;
    }

    .price-unit {
        margin-left: 2px;
        font-size: 12px;
        font-weight: 500;
    }

    /* ===== 富文本描述 ===== */
    .package-desc {
        margin-top: 6px;
        font-size: 12.5px;
        line-height: 1.65;
        color: #8a9099;
        word-break: break-word;
        overflow: hidden;
    }

    .package-desc >>> p {
        margin: 0 0 4px;
    }

    .package-desc >>> p:last-child {
        margin-bottom: 0;
    }

    .package-desc >>> img {
        display: block;
        max-width: 100%;
        height: auto;
        margin: 6px 0;
        border-radius: 8px;
    }

    .package-desc >>> ul,
    .package-desc >>> ol {
        margin: 4px 0;
        padding-left: 18px;
    }

    .package-desc >>> li {
        margin: 2px 0;
    }

    .package-desc >>> a {
        color: #da5b3a;
        text-decoration: none;
    }

    .package-desc >>> h1,
    .package-desc >>> h2,
    .package-desc >>> h3,
    .package-desc >>> h4 {
        margin: 4px 0;
        font-size: 13.5px;
        font-weight: 600;
        color: #4b5563;
    }

    .package-desc >>> table {
        width: 100%;
        border-collapse: collapse;
    }

    .package-desc >>> td,
    .package-desc >>> th {
        padding: 2px 4px;
        border: 1px solid #e9eaee;
    }

    /* ===== 数量选择 ===== */
    .num-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 8px;
        margin-top: 12px;
    }

    .badge-num {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        padding: 0 6px;
        font-size: 13.5px;
        font-weight: 500;
        line-height: 1;
        color: #4b5563;
        background-color: #f4f5f7;
        border: 1px solid #e9eaee;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        user-select: none;
        transition: all 0.18s ease;
    }

    .badge-num:active {
        transform: scale(0.96);
    }

    .badge-num.select {
        color: #fff;
        font-weight: 600;
        background: linear-gradient(135deg, #da5b3a, #e8856b);
        border-color: transparent;
        box-shadow: 0 2px 6px rgba(218, 91, 58, 0.28);
    }

    .more-input {
        width: 100%;
        margin-top: 6px;
    }

    .more-input >>> .mu-text-field {
        font-size: 14px;
    }

    /* ===== 确认勾选 ===== */
    .confirm-card {
        padding: 12px 14px;
        margin-bottom: 12px;
        border-radius: 12px;
        background-color: #fff;
        box-shadow: 0 1px 4px rgba(17, 24, 39, 0.06);
        height: auto;
        min-height: 48px;
        overflow: visible;
        display: flex;
        align-items: flex-start;
    }

    .confirm-card >>> .mu-form-item {
        margin: 0 !important;
        padding: 0 !important;
        height: auto !important;
    }

    .confirm-card >>> .mu-form-item-content {
        height: auto !important;
    }

    /* ===== 底部结算栏 ===== */
    .action-bar {
        position: sticky;
        bottom: 0;
        z-index: 20;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin: auto -14px 0;
        padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
        background-color: rgba(255, 255, 255, 0.97);
        border-top: 1px solid #eef0f3;
        box-shadow: 0 -4px 16px rgba(17, 24, 39, 0.08);
    }

    .total-block {
        display: flex;
        flex-direction: column;
        line-height: 1.2;
    }

    .total-label {
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.5px;
        color: #6b7280;
    }

    .total-value {
        font-size: 28px;
        font-weight: 800;
        line-height: 1.1;
        color: #da5b3a;
        white-space: nowrap;
        text-shadow: 0 1px 2px rgba(218, 91, 58, 0.15);
    }

    .total-value em {
        font-style: normal;
        font-size: 14px;
        font-weight: 600;
    }

    .submit-btn {
        flex-shrink: 0;
        min-width: 140px;
        height: 44px;
        padding: 0 24px;
        border-radius: 22px;
        font-size: 15px;
        font-weight: 600;
        color: #fff !important;
        background: linear-gradient(135deg, #da5b3a, #e8856b) !important;
        box-shadow: 0 4px 12px rgba(218, 91, 58, 0.3);
    }

    .submit-btn[disabled] {
        color: #fff !important;
        background: #c9ccd2 !important;
        box-shadow: none;
        opacity: 0.8;
    }

    /* ===== 已选套餐弹窗 ===== */
    .alert-packages {
        padding: 12px 8px;
        max-height: 200px;
        overflow-y: auto;
    }
    .alert-pkg-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 0;
        border-bottom: 1px solid #eee;
        font-size: 15px;
    }
    .alert-pkg-item:last-child {
        border-bottom: none;
    }
    .alert-pkg-qty {
        color: #da5b3a;
        font-weight: 600;
        font-size: 16px;
        min-width: 32px;
        text-align: right;
    }
    .alert-actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 8px 16px 16px;
    }
    .alert-actions >>> .mu-button {
        margin: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/BuffetSelect.vue